export enum CaseVariant {
  COVER_OUTSIDE = "cover_outside",
  COVER_INSIDE = "cover_inside",
}

export const CASE_VARIANT_LABELS: Record<CaseVariant, string> = {
  [CaseVariant.COVER_OUTSIDE]: "Deckel außen",
  [CaseVariant.COVER_INSIDE]: "Deckel innen",
};
